import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

export default function PatientYBOCSForm() {
    return (
        <PatientFormTemplate formTitle="Yale-Brown Obsessive Compulsive Scale (Y-BOCS)" />
    );
}
